export default function About() {
  return (
    <div className="About-container" id="about">
      <h1>عني</h1>
      <p>
        الشغف هو ما يحركني نحو أي شيء.. شغفي في الكتابة هو الجواب الأكيد في كافة
        مراحل حياتي. ثم تأتي تشعبات تلك الكتابة من صناعة محتوى وابتكار الأفكار
        والتعليق الصوتي والتقديم أمام الكاميرا. هنا أقدم إليكم أعمالي على طبق من
        محبة
      </p>
    </div>
  );
}
